import thunk from 'redux-thunk';
import serverVars from 'server-vars';
import { initializePrerenderedCheckout } from 'dibs-checkout/exports/prerender/initializePrerenderedCheckout';
import { getItemIdFromUri } from '../../utils/getItemIdFormUri';

/* Queries */
import { pdpRespCondensedRootQuery } from '../../queries/pdpRespCondensedRoot';

/* Reducers */
import { defaultReducers } from '../../reducers/reducerUtils';
import { pdpRespMakeOfferModalReducer as makeOfferModal } from '../../reducers/pdpRespMakeOfferModalReducer';

/* Components */
import { PdpRespCondensedLayout } from '../../pdp/PdpRespCondensedLayout';

/* Helpers */
import { createEntry } from '../createEntry';
import { initializeDBL } from 'dibs-buyer-layout/src/entries';
import { datadog, initSharedDatadogRum, pdpTypes } from 'dibs-datadog/exports/datadog';
import { PAGE_TYPE } from 'dibs-constants/exports/pageTypes';
import { setDatadogABTestValues } from 'dibs-ab-tests/exports/clientAbTestV2';
import { storePdpVisit } from '../../pdp/PdpSharedNotifications/pdpSharedNotificationHelpers';

/**
 * DBL has a different environment that's created in initializeDBL.
 */
const options = {
    middleware: [thunk],
    reducers: {
        makeOfferModal,
        ...defaultReducers,
    },
};

const itemId = getItemIdFromUri(window.location.pathname);
if (itemId) {
    storePdpVisit({ itemId });
}

datadog.load().then(dd => {
    initSharedDatadogRum(dd, {
        device: 'resp',
        page: PAGE_TYPE.PDP,
        pageSubType: pdpTypes.condensed,
    });
    setDatadogABTestValues();
});

initializeDBL(options).then(async ({ store }) => {
    createEntry({
        Container: PdpRespCondensedLayout,
        store,
        query: pdpRespCondensedRootQuery,
    });

    const locale = serverVars.get('locale');
    const messages = serverVars.get('messages');

    if (itemId) {
        await initializePrerenderedCheckout({
            isMobile: false,
            itemId,
            locale,
            messages,
        });
    }
});
